// extracted by mini-css-extract-plugin
export default {"footerActions":"FirstStep_footerActions__SkARN"};